import * as React from "react";

import { Box, Grid, Typography } from "@mui/material";

import CustomInput from "../../../../helper-components/input/CustomInput";
import CustomButton from "../../../../helper-components/input/CustomButton";

import { validateRow } from "../../../../helper-functions/validation/objectValidation";
import { addFormToObj, setInsertObjectState, setValue } from "../../../../helper-functions/shared/miscUtils";
import { IS_USER_CREATE_VALID, USER_CREATE_VALIDATION } from "../../../../helper-functions/validation/userValidation";

import { getLanguage } from "../../../../config/language/language";
import { ROLE_TYPES, USER_CREATE_REQUEST_OBJECT } from "../../../../config/constants/Constants";

/**
 * A form for an admin to create a new user.
 *
 * Unlike sign-up, the admin picks the role and whether the account is enabled straight away,
 * so the new user can sign in without a separate approval step.
 */
export default function UserAddForm(props) {
    // Because modals don't re-render if the props' state changes, use a callback.
    const { callback } = props;

    const object = USER_CREATE_REQUEST_OBJECT;
    const validation = USER_CREATE_VALIDATION;

    const [row, setRow] = React.useState(addFormToObj(JSON.parse(JSON.stringify(object))));

    const roleOptions = ROLE_TYPES.map((r) => r.role);

    /**
     * Executed when typing something into an input field.
     */
    const onChange = (obj, key, value) => {
        const newUser = JSON.parse(JSON.stringify(row));
        setValue(newUser, key, value);

        if (key === "_role") {
            const role = ROLE_TYPES.find((r) => r.role === value);
            setValue(newUser, "role_id", role?.id ?? "");
        }

        validateRow(obj, validation, newUser);
        setInsertObjectState(setRow, newUser);
    };

    const handleClick = () => {
        if (!IS_USER_CREATE_VALID(row)) {
            props.showSnackbar({ message: getLanguage().SNACKBAR_ERROR_FORM_INVALID, color: "error" });
            return;
        }

        callback(true, { row });
    };

    return (
        <Box className="box">
            <Grid container spacing={1}>
                <Grid item xs={12} sx={{ textAlign: "center" }}>
                    <CustomInput name="enabled" row={row} onChange={onChange} label="Enable account" switch />
                </Grid>

                <Grid item xs={12}>
                    <CustomInput name="username" row={row} onChange={onChange} label="Username" />
                </Grid>

                <Grid item xs={12}>
                    <CustomInput name="email" row={row} onChange={onChange} label="Email" />
                </Grid>

                <Grid item xs={12}>
                    <CustomInput name="password" row={row} onChange={onChange} label="Initial password" type="password" />
                </Grid>

                <Grid item xs={12}>
                    <CustomInput name="_role" row={row} onChange={onChange} label="Role" select={roleOptions} />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary">
                        {getLanguage().ROLE_DESCRIPTION[row._role] || getLanguage().ROLE_DESCRIPTION.USER}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
                        The user can change their username, email and password themselves from the Account page.
                    </Typography>
                </Grid>
            </Grid>

            <CustomButton {...props} title={"Create user"} onClick={handleClick} className="button" fullWidth />
        </Box>
    );
}
